<template>
  <div class="enterpriseAddOrder">
    <QS-scroller-box>
      <QS-h3-title title="新增租赁车辆" />
      <!-- eslint-disable vue/no-unused-refs -->
      <RelationOrderInfo
        v-if="showRelationOrderInfo"
        ref="RelationOrderInfo"
        :m_relationOrderInfo="m_relationOrderInfo"
        :m_relationOrderInfoModel="m_relationOrderInfoModel"
        :relatedType="configParams.relatedType"
      />
      <!-- eslint-enable vue/no-unused-refs -->
      <!--  企业租赁 客户信息-->
      <QS-h4-title title="客户信息" />
      <form-text-box
        ref="customerInfo"
        :dataList="m_customerInfo"
        :model="m_customerInfoModel"
      />
      <!-- 企业选择车辆 -->
      <AddVehicle
        ref="AddVehicle"
        :addVehicleTable="addVehicleTable"
        :maxVehicle="maxVehicle"
        :showBatch="showBatch"
        :planId="selectPlanId"
        :m_addVehicle="m_addVehicle"
        :m_addVehicleModel="m_addVehicleModel"
      />
      <!-- 租赁信息 -->
      <QS-h4-title title="租赁信息" />
      <!-- 确认租赁信息 -->
      <rentInfo
        ref="rentInfo"
        :planId="selectPlanId"
        :isEnterChildOrder="true"
        @updateInfo="updateRentDateInfo"
      />
      <!-- 租赁信息文本展示和支付计划表格 -->
      <rentLeasePlanInfo
        ref="rentLeasePlanInfo"
        :defaultTableData="feeTableData"
        :rentDateInfo="rentDateInfo"
        @autoAnchor="autoAnchor"
      />
      <template slot="bottomAction">
        <el-button size="small" @click="addCancel">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="addEnterpriseOrder"
          :loading="overLoading"
        >
          {{
            `${
              this.configParams.relatedType === 2 && dingTalkShow
                ? approvalStatus
                  ? '再次提交钉钉审批'
                  : '提交钉钉审批'
                : '确认'
            }`
          }}
        </el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// api
// eslint-disable-next-line import/no-cycle
import { addleaseOrderCarSignCheck } from '@/api/carManage'
import * as globalApi from '@/api/global'
import { getLeasingSchemeConfigList } from '@/api/purchaseAndSaleAPI'
// 组件
import rentInfo from '@/components/rentCalculateConfig/rentInfo.vue'
import rentLeasePlanInfo from '@/components/rentCalculateConfig/rentLeasePlanInfo.vue'
import RelationOrderInfo from '../components/RelationOrderInfo.vue'
import AddVehicle from './components/AddVehicle.vue'
// 配置
import publicConfigData from '../config/index'
import configData from './config'
//  其他依赖
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'enterpriseAddOrder',
  components: {
    AddVehicle,
    RelationOrderInfo,
    rentInfo,
    rentLeasePlanInfo,
  },
  data() {
    const {
      // 客户信息
      m_customerInfo,
      m_customerInfoModel,
      // 车辆选择
      m_addVehicle,
      m_addVehicleModel,
    } = configData.call(this)
    const {
      // 关联订单
      m_relationOrderInfo,
      m_relationOrderInfoModel,
      // 租赁信息
      m_rules,
      ladderSchemeConfig, // 阶梯配置
    } = publicConfigData.call(this)
    return {
      m_customerInfo,
      m_customerInfoModel,
      m_addVehicle,
      m_addVehicleModel,
      m_relationOrderInfo,
      m_relationOrderInfoModel,
      // eslint-disable-next-line vue/no-unused-properties
      m_rules,
      // eslint-disable-next-line vue/no-unused-properties
      ladderSchemeConfig,
      configParams: {
        relatedType: 0,
      },
      selectPlanId: null,
      // 支付计划
      tableDataFrom: {
        tableData: [],
      },
      rentPlanList: [], // 租赁方案
      defaultTableData: [], // 默认支付计划
      // 租赁信息
      leaseInfoParams: {
        // eslint-disable-next-line vue/no-unused-properties
        signDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签署日期
        category: 1, // 类别
        startStopDate: [], // 起止日期
        presentDays: '', // 赠送天数
        freedomCycle: '', // 免租周期
      },
      rentDateInfo: {
        rentCategory: '', // 类别
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
      },
      feeTableData: [],
      // eslint-disable-next-line vue/no-unused-properties
      from_check: {},
      overLoading: false,
      addVehicleTable: [], // 选择车辆
      maxVehicle: -1, // 允许添加的最大车辆数  -1 表示不限制
      showBatch: true, // 是否展示批量添加车辆功能
      dingTalkShow: false, // 是否开启钉钉审批流
      approvalStatus: false, // 是否审批中
    }
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line vue/no-unused-properties
      categoryList: (state) => state.global.categoryList, // 类别
    }),
    // 关联订单信息展示
    showRelationOrderInfo() {
      return this.configParams.relatedType
    },
  },
  watch: {
    // 计算免租周期
    'leaseInfoParams.presentDays': {
      handler(val) {
        if (!val || Number(val) === 0) {
          this.leaseInfoParams.freedomCycle = ''
          return false
        }
        let at = ''
        let st = ''
        let et = ''
        if (
          val &&
          this.leaseInfoParams.startStopDate &&
          this.leaseInfoParams.startStopDate.length > 0
        ) {
          at = new Date(this.leaseInfoParams.startStopDate[1]).getTime() + 1000
          st = `${moment(at).format('YYYY-MM-DD')} 00:00:00`
          et = `${moment(st)
            .add(val - 1, 'days')
            .format('YYYY-MM-DD')} 23:59:59`
          this.leaseInfoParams.freedomCycle = [st, et]
        }
      },
      deep: true,
    },
    // 计算免租周期
    'leaseInfoParams.startStopDate': {
      handler(val) {
        if (!val || val.length === 0) {
          return false
        }
        let at = ''
        let st = ''
        let et = ''
        if (val.length && this.leaseInfoParams.presentDays) {
          at = new Date(val[1]).getTime() + 1000
          st = `${moment(at).format('YYYY-MM-DD')} 00:00:00`
          et = `${moment(st)
            .add(this.leaseInfoParams.presentDays - 1, 'days')
            .format('YYYY-MM-DD')} 23:59:59`
          this.leaseInfoParams.freedomCycle = [st, et]
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = {
        ...val,
      }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.rentInfo.autoAnchorPoint(toastFlag)
    },
    // 获取参数
    getParameter() {
      this.tableDataFrom.tableData = this.$refs.rentLeasePlanInfo.getFormData()
      this.leaseInfoParams.startDate = this.leaseInfoParams.startStopDate[0]
      this.leaseInfoParams.endDate = this.leaseInfoParams.startStopDate[1]
      this.leaseInfoParams.presentStartDate = this.leaseInfoParams.freedomCycle[0]
      this.leaseInfoParams.presentEntDate = this.leaseInfoParams.freedomCycle[1]
      this.tableDataFrom.tableData &&
        this.tableDataFrom.tableData.forEach((ele) => {
          // this.leaseInfoParams.category === 3：类别为司机合作模式
          // fundType === 1：收款项为租金
          if (ele.fundType === 1 && this.leaseInfoParams.category === 3) {
            ele.planAmount = ''
            ele.payDay = ''
            ele.payPost = ''
            ele.presentDays = ''
            ele.totalCycle = ''
            ele.payDate = ''
            ele.payMode = ''
          }
        })
      return {
        ...this.m_customerInfoModel,
        ...this.leaseInfoParams,
        ...this.m_relationOrderInfoModel,
        ...this.configParams,
        carInfoList: this.addVehicleTable,
        orderAccruedPlans: this.tableDataFrom.tableData,
        ...this.$refs.rentInfo.getFormData(),
      }
    },
    // 新增企业订单
    async addEnterpriseOrder() {
      if (!this.addVehicleTable.length) {
        this.$message.error('车辆不能为空')
        this.$refs.AddVehicle.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        return
      }

      if (
        !this.$refs.rentLeasePlanInfo.getFormData() ||
        !this.$refs.rentInfo.getFormData()
      ) { return }

      const params = {
        ...this.getParameter(),
      }

      if (this.configParams.relatedType === 2) {
        Object.assign(params, {
          bizType: 10, // 企业子订单换车审批
          approvalAccessModeType: this.dingTalkShow ? 2 : 1, // 是否开启钉钉审批
        })
      }

      const res = await addleaseOrderCarSignCheck({
        ...params,
      })
      const { code } = res
      if (code === 1) {
        this.$message.success('添加成功')
        this.addCancel()
      }
    },
    // 获取钉钉审批按钮开启
    getDingTalkBtnShow() {
      globalApi
        .getSubmitDingTalkShow({ bizType: 10 })
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.dingTalkShow = data
          }
        })
    },
    // 选择租赁方案
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      if (Number(id) === 0) {
        // 自定义
        this.selectPlanId = Number(id)
        this.$refs.rentInfo.resetFormData()
        this.m_customerInfoModel.planRecordId = '' // 上架单ID
        this.m_addVehicleModel = {
          brandSeriesModel: {},
          brandSeriesModelName: {},
        } // 车辆选择重置

        // 清空起止日期
        this.leaseInfoParams.startStopDate = []
        return
      }

      this.rentPlanList.forEach((item) => {
        if (item.id !== id) return
        this.selectPlanId = Number(item.id)
        // 回显上架单ID
        const { modelId, planRecordId, brandId, seriesId } = item
        this.m_customerInfoModel.planRecordId = planRecordId

        // 车型id
        this.m_addVehicleModel = {
          ...this.m_addVehicleModel,
          modelId,
          brandSeriesModel: {
            brandId,
            seriesId,
            modelId,
          },
          brandSeriesModelName: {
            brandName: item.brandName,
            seriesName: item.seriesName,
            modelName: item.modelName,
          },
        }

        // 子组件还拿不到才更新的数据 所以放在nextTick里
        this.$nextTick(() => {
          // 获取车辆列表
          this.$refs.AddVehicle.plateNoRemoteMethod()
        })
      })
    },
    init() {
      const {
        relationOrderType = 0,
        orderId = '',
        customerName = '',
        customerId = '',
        deposit,
        approvalStatus = 0,
      } = this.$route.query
      this.approvalStatus = Number(approvalStatus)
      this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' }) // 获取付款方式
      this.configParams.orderId = orderId
      this.m_customerInfoModel.customerId = customerId
      this.m_customerInfoModel.customerName = customerName
      this.getRentPlanList() // 获取租赁方案
      if (Number(relationOrderType) === 2) {
        // 关联订单处理
        this.handlerRelationOrder()
        // 默认支付计划项
        this.defaultTableData = [
          {
            fundType: 2, // 押金
            payMode: 6, // 一次性
            totalCycle: 1, // 期数
            payDate: new Date(), // 收款日期
            defaultTableData: true, // 默认tableData
            planAmount: deposit,
          },
        ]
        this.feeTableData = [...this.defaultTableData]
        // 是否开启钉钉审批
        this.getDingTalkBtnShow()
      }
    },
    handlerRelationOrder() {
      const { relationOrderType = 0, contractId } = this.$route.query
      this.configParams.relatedOrderId = Number(contractId)
      this.configParams.relatedType = Number(relationOrderType)
    },
    // 获取租赁方案
    getRentPlanList() {
      getLeasingSchemeConfigList({
        orderType: 2, // 1 个人  2 企业
        state: 1,
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        const { data } = res
        const { items } = data
        this.rentPlanList = items
        this.$refs.customerInfo.setItemData({
          elConfigKey: 'list',
          key: 'planId',
          data: [...items, { id: 0, name: '自定义' }],
        })
      })
    },
    // 取消按钮点击事件
    addCancel() {
      this.$refreshBack() // 关闭当前tab
    },
  },
}
</script>
